import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";
import "./Admin.scss";

const AddMedicineForm = ({closeModal, onMedicineAdded}) => {
  const [formData, setFormData] = useState({
    name: "",
    substitutes: "",
    diseases: "",
    category: "",
    stock: "",
    price: "",
    description: "",
    prescription: true,
  });

  const [image, setImage] = useState(null);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleFileChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      form.append(key, value);
    });

    if (image) {
      form.append("image", image);
    }

    try {
      const { data } = await axios.post("/medicines", form, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });

      console.log("Medicine added:", data);
      toast.success("Medicine added successfully!");
      onMedicineAdded();
      closeModal(); 
    } catch (err) {
      console.error("Add medicine failed:", err.response?.data?.error || err.message);
      toast.error("Failed to add medicine. Please try again.");
      if (err.response?.data?.error) {
        toast.error(err.response.data.error);
      }
    }
  };

  return (
    <form className="medicine-form" onSubmit={handleSubmit}>
      <h2>Add New Medicine</h2>
      <button type="button" className="close-modal" onClick={closeModal}>
        &times; 
      </button>
      <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Name" required />
      <input type="text" name="substitutes" value={formData.substitutes} onChange={handleChange} placeholder="Substitutes (comma-separated)" />
      <input type="text" name="diseases" value={formData.diseases} onChange={handleChange} placeholder="Diseases (comma-separated)" />
      <input type="text" name="category" value={formData.category} onChange={handleChange} placeholder="Category" />
      <input type="number" name="stock" value={formData.stock} onChange={handleChange} placeholder="Stock" />
      <input type="text" name="price" value={formData.price} onChange={handleChange} placeholder="Price" required />
      <textarea name="description" value={formData.description} onChange={handleChange} placeholder="Description" />
      <select name="prescription" value={formData.prescription} onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              prescription: e.target.value === "required",
            }))
          }>
        <option value="required">Prescription Required</option>
        <option value="not_required">No Prescription</option>
      </select>
      <input type="file" accept="image/*" onChange={handleFileChange} />
      <button type="submit">Add Medicine</button>
    </form>
  );
};

export default AddMedicineForm;
